import { render, staticRenderFns } from "./qyInfo.vue?vue&type=template&id=ca933354&scoped=true&"
import script from "./qyInfo.vue?vue&type=script&lang=js&"
export * from "./qyInfo.vue?vue&type=script&lang=js&"
import style0 from "./qyInfo.vue?vue&type=style&index=0&id=ca933354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca933354",
  null
  
)

export default component.exports